module.exports = ".guidance-tooltip .guidance-tooltip-link{text-align:end;width:100%}";